import { render, staticRenderFns } from "./CompanyGradeItem.vue?vue&type=template&id=61f4c9ef&scoped=true&"
import script from "./CompanyGradeItem.vue?vue&type=script&lang=js&"
export * from "./CompanyGradeItem.vue?vue&type=script&lang=js&"
import style0 from "./CompanyGradeItem.vue?vue&type=style&index=0&id=61f4c9ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f4c9ef",
  null
  
)

export default component.exports